import React, { useState } from 'react';
import { Star, Heart, MessageSquare, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const ALL_REVIEWS = [{
  user: '@marta_terapias',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Increíble el material, ya estoy usando las tiradas terapéuticas y las preguntas de exploración en mis sesiones de los martes.',
  likes: 12,
  time: '2 horas'
}, {
  user: '@carina_lecturas',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'El manual fundamental es lo que me faltaba para dar estructura a mis lecturas. ¡Gracias por este aporte tan valioso!',
  likes: 8,
  time: '4 horas'
}, {
  user: '@ana_sanacion_tarot',
  avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Muy completo todo, la biblioteca de preguntas está bárbara para profundizar en cada carta sin caer en lo predictivo.',
  likes: 15,
  time: '6 horas'
}, {
  user: '@graciela_facilitadora',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Las fichas de anamnesis son de otro planeta. Mis consultantes quedan impactados con el seguimiento profesional que les doy ahora.',
  likes: 21,
  time: '8 horas'
}, {
  user: '@tarot_terapeutico_pro',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Por fin algo profesional y bien organizado para terapeutas de tarot. El diario de evolución es genial para mis alumnas.',
  likes: 34,
  time: '12 horas'
}, {
  user: '@sofi_intuicion',
  avatar: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'El sistema de interpretación me voló la cabeza. Muy recomendado para quienes buscan profundidad emocional en el mazo.',
  likes: 19,
  time: '1 día'
}, {
  user: '@paula_holistica',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Excelente soporte y el material sobre protección energética es de primera calidad. Ya no termino cansada las sesiones.',
  likes: 7,
  time: '1 día'
}, {
  user: '@caro_tarot_terapia',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Me sirvió mucho para entender cómo acompañar procesos emocionales complejos a través de los arcanos mayores.',
  likes: 11,
  time: '2 días'
}, {
  user: '@espacio_tarot_fem',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Las guías de lectura son súper fáciles de seguir. Muy práctico para la consulta diaria y para organizar el espacio.',
  likes: 25,
  time: '2 días'
}, {
  user: '@juana_terapeuta',
  avatar: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Un antes y un después en mi práctica profesional. El tarot terapéutico ahora es mi guía diaria para el acompañamiento.',
  likes: 42,
  time: '3 días'
}, {
  user: '@marta_sanadora',
  avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Lo compré ayer y ya devoré el manual de interpretación. ¡Es oro puro para quienes trabajamos con el alma!',
  likes: 14,
  time: '3 días'
}, {
  user: '@vibrando_tarot',
  avatar: 'https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'El protocolo de protección es clave, ya no me cargo con las energías de las lecturas difíciles. Muy agradecida.',
  likes: 28,
  time: '4 días'
}, {
  user: '@luz_terapeutica',
  avatar: 'https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Muy agradecida por compartir este conocimiento sobre el tarot tan valioso y bien estructurado.',
  likes: 16,
  time: '4 días'
}, {
  user: '@terapias_tarot_pro',
  avatar: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'El kit más completo que vi en mucho tiempo para trabajar con consultantes de forma seria y profesional.',
  likes: 31,
  time: '5 días'
}, {
  user: '@ser_consciente_mujer',
  avatar: 'https://images.unsplash.com/photo-1548142813-c348350df52b?auto=format&fit=crop&q=80&w=100&h=100',
  text: 'Las guías de seguimiento para integrar la lectura son un plus increíble que no encontré en ningún otro curso.',
  likes: 9,
  time: '5 días'
}];
export function Reviews() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (comment.trim()) {
      setShowPopup(true);
      setComment('');
      setRating(0);
    }
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, ALL_REVIEWS.length));
  };
  return <section className="py-8 bg-transparent" data-id="element-310" data-mp="onviuc37j0w0">
      <div className="max-w-xl mx-auto px-4" data-id="element-311" data-mp="jq3svnm4houg">
        <h2 className="text-purple-950 mb-4 text-center uppercase italic tracking-widest opacity-50 font-magical text-[24px] font-[900]" data-id="element-312" data-mp="jsztjjpcurml">
          comentarios
        </h2>

        <div className="bg-white p-4 rounded-2xl border border-purple-100 mb-6 shadow-sm" data-id="element-313" data-mp="9tio93e0mfr5">
          <h3 className="text-purple-950 font-bold mb-2 text-sm" data-id="element-314" data-mp="517cn39wx5ir">
            Deja tu reseña:
          </h3>
          <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe aquí..." className="w-full bg-purple-50/30 border border-purple-100 rounded-lg p-3 text-zinc-800 text-sm focus:border-purple-500 outline-none transition-colors mb-3 min-h-[60px]" data-id="element-315" data-mp="10x7ttxuwl5h" />
          <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-316" data-mp="3i9k5ycv3x83k">
            <div className="flex items-center gap-2" data-id="element-317" data-mp="38kdlmj5gu6dm">
              <span className="text-zinc-400 text-[10px]" data-id="element-318" data-mp="38jlr7bnlueox">Calificar:</span>
              <div className="flex gap-1" data-id="element-319" data-mp="3dksuoyipsrps">
                {[1, 2, 3, 4, 5].map(s => <button key={s} onClick={() => setRating(s)} className={`${rating >= s ? 'text-amber-400' : 'text-zinc-200'} hover:scale-110 transition-transform`} data-id="element-320" data-mp="2zkqgpndj2ift">
                    <Star size={20} fill={rating >= s ? 'currentColor' : 'none'} data-id="element-321" data-mp="33nn4dshxd4qm" />
                  </button>)}
              </div>
            </div>
            <button onClick={handlePublish} className="bg-purple-600 text-white font-black px-6 py-2 rounded-full hover:bg-purple-700 transition-colors uppercase text-xs shadow-md" data-id="element-322" data-mp="41yqeurd0ax">
              Publicar
            </button>
          </div>
        </div>

        <div className="space-y-3" data-id="element-323" data-mp="3miblykmyc2a4">
          {ALL_REVIEWS.slice(0, visibleCount).map((rev, i) => <div key={i} className="border-b border-purple-50 pb-3" data-id="element-324" data-mp="e2rwlwpej40c" data-mpi={i}>
              <div className="flex items-center justify-between mb-0.5" data-id="element-325" data-mp="iweattb7rfy9">
                <div className="flex items-center gap-2" data-id="element-326" data-mp="23l8bbgkaf0pe">
                  <span className="text-purple-600 font-bold text-[10px]" data-id="element-327" data-mp="23jnetleex7ow">
                    {rev.user}
                  </span>
                </div>
                <div className="flex text-amber-400/60" data-id="element-328" data-mp="2darvcpjql0lu">
                  {[...Array(5)].map((_, i) => <Star key={i} size={8} fill="currentColor" data-id="element-329" data-mp="28cgj685yye0g" data-mpi={i} />)}
                </div>
              </div>
              <p className="text-zinc-600 text-xs mb-1.5" data-id="element-330" data-mp="1kmckmf7n14gb">{rev.text}</p>
              <div className="flex items-center gap-3 text-[9px] text-zinc-400" data-id="element-331" data-mp="1foay1kb06n03">
                <button className="flex items-center gap-1 hover:text-purple-600 transition-colors" data-id="element-332" data-mp="1fqfe10m6fcgq">
                  <Heart size={10} data-id="element-333" data-mp="1uiz3wzkbfng8" /> {rev.likes}
                </button>
                <span data-id="element-334" data-mp="1pkxhq5rlf80j">hace {rev.time}</span>
              </div>
            </div>)}
          {visibleCount < ALL_REVIEWS.length && <button onClick={loadMore} className="w-full py-3 text-zinc-400 font-bold hover:text-purple-600 transition-colors uppercase text-xs tracking-widest" data-id="element-335" data-mp="362bjmnv6x4up">
              Cargar 5 comentarios más
            </button>}
        </div>
      </div>

      <AnimatePresence data-id="element-336" data-mp="13d1ru7hq4bio">
        {showPopup && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-blue-950/40 backdrop-blur-sm" data-id="element-337" data-mp="13e39wvx5py9w">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white border-2 border-blue-600 p-8 rounded-3xl max-w-sm w-full text-center shadow-2xl" data-id="element-338" data-mp="18b3fz6u0b110">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white" data-id="element-339" data-mp="1r3nsvetb8vj6">
                <CheckCircle2 size={32} data-id="element-340" data-mp="1w1fsyw43znyg" />
              </div>
              <h4 className="text-xl font-black text-blue-950 mb-2" data-id="element-341" data-mp="3sur4o7exsg5b">
                ¡Gracias por tu comentario!
              </h4>
              <p className="text-blue-800/60 mb-6" data-id="element-342" data-mp="1noenjau4fwo">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowPopup(false)} className="w-full bg-blue-950 text-white font-black py-3 rounded-xl uppercase text-xs" data-id="element-343" data-mp="3qb4fj7koexyk">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}